import React from 'react';
import { SNOWFLAKE_2026_TIMELINE } from '../../../content/snowflakeUpdates';

function StatusBadge({ status }) {
  const preview = status !== 'GA';
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold uppercase tracking-wide ${
        preview
          ? 'bg-brand-50 text-brand-800 ring-1 ring-inset ring-brand-200'
          : 'bg-brand-900 text-white'
      }`}
    >
      {status}
    </span>
  );
}

export default function SnowflakeTimeline() {
  return (
    <section aria-labelledby="snowflake-2026-timeline">
      <h2
        id="snowflake-2026-timeline"
        className="scroll-mt-48 font-display text-2xl font-semibold tracking-tight text-brand-900 sm:text-3xl"
      >
        Snowflake 2026 timeline
      </h2>
      <p className="mt-3 max-w-3xl text-base leading-relaxed text-ink-600">
        General availability and preview only. Each month shows the items most relevant to a team
        whose agents answer from a semantic view. The date is the day Snowflake published the note.
      </p>
      <ol className="mt-8 space-y-8">
        {SNOWFLAKE_2026_TIMELINE.map((month) => (
          <li
            key={month.month}
            className="grid grid-cols-1 gap-3 sm:grid-cols-[7.5rem_minmax(0,1fr)] sm:gap-6"
          >
            <h3 className="sm:pt-3">
              <span className="updates-chip inline-flex rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide">
                {month.month}
              </span>
            </h3>
            <ol className="min-w-0 space-y-3 border-l-2 border-brand-700 pl-5">
              {month.items.map((item) => (
                <li
                  key={`${item.iso}-${item.title}`}
                  className="relative rounded-xl border border-brand-100 bg-white shadow-xs"
                >
                  <span
                    aria-hidden="true"
                    className="absolute -left-[27px] top-5 h-3 w-3 rounded-full border-2 border-white bg-brand-500"
                  />
                  <div className="rounded-t-xl border-b border-brand-100 bg-brand-50 px-4 py-3">
                    <div className="flex flex-wrap items-center gap-2">
                      <time dateTime={item.iso} className="text-xs font-bold text-brand-700">
                        {item.date}
                      </time>
                      <StatusBadge status={item.status} />
                    </div>
                    <p className="mt-1 font-display text-base font-semibold text-brand-900">{item.title}</p>
                  </div>
                  <div className="p-4">
                    <p className="text-sm leading-relaxed text-ink-600">{item.summary}</p>
                    <div className="mt-3 flex flex-col gap-1">
                      {(item.links || [{ href: item.href, source: item.source }]).map((link) => (
                        <a
                          key={link.href}
                          href={link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex text-sm font-medium text-brand-700 underline decoration-brand-400 underline-offset-2 hover:text-brand-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-700"
                        >
                          {link.source}
                          <span className="sr-only"> (opens in a new tab)</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </li>
        ))}
      </ol>
    </section>
  );
}
